import styled from 'styled-components';

const Wrapper = styled.section`
  .form-control {
    margin-bottom: 1.25rem;
    h5 {
      margin-bottom: 0.5rem;
    }
  }
    
  .search-input {
    padding: 0.5rem;
    background: var(--clr-grey-10);
    border-radius: var(--radius);
    letter-spacing: var(--spacing);
    width: 100%;
  }
  .search-input::placeholder {
    text-transform: capitalize;
  }

  button {
    display: block;
    margin: 0.25em 0;
    padding: 0.25rem 0;
    text-transform: capitalize;
    background: transparent;
    border: none;
    border-bottom: 1px solid transparent;
    letter-spacing: var(--spacing);
    color: var(--clr-grey-5);
    cursor: pointer;
  }

  .colorIcon{
    margin-right: 5px
  }
  
  .company {
    background: var(--clr-grey-10);
    border-radius: var(--radius);
    border-color: transparent;
    padding: 0.25rem;
  }
  
  .color-btn {
    display: inline-block;
    width: 8rem;
    height: 1.5rem;
    border-radius: 5px;
    margin-right: 0.5rem;
    border: none;
    cursor: pointer;
    opacity: 0.5;
    display: flex;
    align-items: center;
    justify-content1: flex-start;
    color: black;
    svg {
      font-size: 0.5rem;
      color: var(--clr-white);
    }
  }

  

  .active {
    border-color: var(--clr-grey-5);
  }

  .all-btn {
    display: flex;
    align-items: center;
    justify-content1: center;
    margin-right: 0.5rem;
    opacity: 0.5;
  }
  .active {
    opacity: 1;
  }
  .all-btn .active {
    text-decoration: underline;
  }
  .price {
    margin-bottom: 0.25rem;
  }
  .shipping {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    text-transform: capitalize;
    column-gap: 0.5rem;
    font-size: 1rem;
  }
  .clear-btn {
    background: black;
    color: var(--clr-white);
    padding: 0.25rem 0.5rem;
    border-radius: var(--radius);
    margin-left: auto;
    margin-right: auto;
    margin-top: 15px;
  }
  @media (min-width: 768px) {
    .content1 {
      position: sticky;
      top: 1rem;
    }
  }

  }

`;

export default Wrapper;
